import { takeLatest, put, call } from "redux-saga/effects";
import { ShowError, ShowSucess } from "../../_helper/helper";
import { getFormalApiErrorMessage } from "../../utils/apiError";

import {
  GET_UNMAPPED_POSITIONS,
  GET_UNMATCHED_CLASSIFICATIONS,
  GET_NO_CLASSIFICATION_POSITIONS,
  GET_CLASSIFICATIONS_LOOKUP,
  PROPOSE_POSITION_MAPPING,
  GET_PENDING_POSITION_MAPPINGS,
  DECIDE_POSITION_MAPPING,
  GET_MY_MAPPING_HISTORY,
} from "./actionTypes";

import {
  getUnmappedPositionsSuccess,
  getUnmappedPositionsFail,
  getUnmatchedClassificationsSuccess,
  getUnmatchedClassificationsFail,
  getPositionsWithNoClassificationSuccess,
  getPositionsWithNoClassificationFail,
  getClassificationsLookupSuccess,
  getClassificationsLookupFail,
  proposePositionMappingSuccess,
  proposePositionMappingFail,
  getPendingPositionMappingsSuccess,
  getPendingPositionMappingsFail,
  decidePositionMappingSuccess,
  decidePositionMappingFail,
  getMyMappingHistorySuccess,
  getMyMappingHistoryFail,
} from "./actions";

import {
  getUnmappedPositions,
  getUnmatchedClassifications,
  getPositionsWithNoClassification,
  getClassificationsLookup,
  proposePositionMapping,
  getPendingPositionMappings,
  decidePositionMapping,
  getPositionMappingHistory,
} from "../../_helper/services/positionMapping";

function* onGetUnmappedPositions() {
  try {
    const response = yield call(getUnmappedPositions);
    yield put(getUnmappedPositionsSuccess(response));
  } catch (error) {
    yield put(getUnmappedPositionsFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetUnmatchedClassifications() {
  try {
    const response = yield call(getUnmatchedClassifications);
    yield put(getUnmatchedClassificationsSuccess(response));
  } catch (error) {
    yield put(getUnmatchedClassificationsFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetPositionsWithNoClassification() {
  try {
    const response = yield call(getPositionsWithNoClassification);
    yield put(getPositionsWithNoClassificationSuccess(response));
  } catch (error) {
    yield put(getPositionsWithNoClassificationFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetClassificationsLookup() {
  try {
    const response = yield call(getClassificationsLookup);
    yield put(getClassificationsLookupSuccess(response));
  } catch (error) {
    yield put(getClassificationsLookupFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onProposePositionMapping({ payload }) {
  try {
    const response = yield call(proposePositionMapping, payload);
    yield put(proposePositionMappingSuccess(response));
    ShowSucess(
      payload.requestType === "NewClassification"
        ? "Flagged for Payroll to create a new job classification"
        : "Mapping proposal submitted for Payroll approval",
      { position: "top-right" }
    );
    // A proposal can come from any of the three lists - refresh all so the row
    // disappears from whichever one it came from.
    yield call(onGetUnmappedPositions);
    yield call(onGetUnmatchedClassifications);
    yield call(onGetPositionsWithNoClassification);
    yield call(onGetMyMappingHistory);
  } catch (error) {
    yield put(proposePositionMappingFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetPendingPositionMappings() {
  try {
    const response = yield call(getPendingPositionMappings);
    yield put(getPendingPositionMappingsSuccess(response));
  } catch (error) {
    yield put(getPendingPositionMappingsFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onDecidePositionMapping({ payload: { id, ...rest } }) {
  try {
    const response = yield call(decidePositionMapping, id, rest);
    yield put(decidePositionMappingSuccess(response));
    ShowSucess(
      rest.decision === "Approved" ? "Mapping approved" : "Mapping rejected",
      { position: "top-right" }
    );
    yield call(onGetPendingPositionMappings);
  } catch (error) {
    yield put(decidePositionMappingFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onGetMyMappingHistory() {
  try {
    const response = yield call(getPositionMappingHistory);
    yield put(getMyMappingHistorySuccess(response));
  } catch (error) {
    yield put(getMyMappingHistoryFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* PositionMappingSaga() {
  yield takeLatest(GET_UNMAPPED_POSITIONS, onGetUnmappedPositions);
  yield takeLatest(GET_UNMATCHED_CLASSIFICATIONS, onGetUnmatchedClassifications);
  yield takeLatest(GET_NO_CLASSIFICATION_POSITIONS, onGetPositionsWithNoClassification);
  yield takeLatest(GET_CLASSIFICATIONS_LOOKUP, onGetClassificationsLookup);
  yield takeLatest(PROPOSE_POSITION_MAPPING, onProposePositionMapping);
  yield takeLatest(GET_PENDING_POSITION_MAPPINGS, onGetPendingPositionMappings);
  yield takeLatest(DECIDE_POSITION_MAPPING, onDecidePositionMapping);
  yield takeLatest(GET_MY_MAPPING_HISTORY, onGetMyMappingHistory);
}

export default PositionMappingSaga;
